import { render, staticRenderFns } from "./CoastsAlertsHeader.vue?vue&type=template&id=4750230a&scoped=true"
import script from "./CoastsAlertsHeader.vue?vue&type=script&lang=js"
export * from "./CoastsAlertsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4750230a",
  null
  
)

export default component.exports